var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c("p", { staticClass: "d2-mt-0" }, [_vm._v("$log.capsule")]),
      _c(
        "el-button",
        {
          attrs: { size: "small", type: "primary" },
          on: {
            click: function($event) {
              return _vm.$log.capsule("title", "primary")
            }
          }
        },
        [_vm._v(" $log.capsule('title', 'primary') ")]
      ),
      _c(
        "el-button",
        {
          attrs: { size: "small", type: "success" },
          on: {
            click: function($event) {
              return _vm.$log.capsule("title", "success", "success")
            }
          }
        },
        [_vm._v(" $log.capsule('title', 'success', 'success') ")]
      ),
      _c(
        "el-button",
        {
          attrs: { size: "small", type: "warning" },
          on: {
            click: function($event) {
              return _vm.$log.capsule("title", "warning", "warning")
            }
          }
        },
        [_vm._v(" $log.capsule('title', 'warning', 'warning') ")]
      ),
      _c(
        "el-button",
        {
          attrs: { size: "small", type: "danger" },
          on: {
            click: function($event) {
              return _vm.$log.capsule("title", "danger", "danger")
            }
          }
        },
        [_vm._v(" $log.capsule('title', 'danger', 'danger') ")]
      ),
      _c("p", [_vm._v("$log.colorful")]),
      _c(
        "el-button",
        { attrs: { size: "small" }, on: { click: _vm.handleColorful } },
        [_vm._v(" colorful ")]
      ),
      _c("p", [_vm._v("$log.default | primary | success | warning | danger")]),
      _c(
        "el-button",
        {
          attrs: { size: "small" },
          on: {
            click: function($event) {
              return _vm.$log.default("default style")
            }
          }
        },
        [_vm._v(" $log.default('default style') ")]
      ),
      _c(
        "el-button",
        {
          attrs: { size: "small", type: "primary" },
          on: {
            click: function($event) {
              return _vm.$log.primary("primary style")
            }
          }
        },
        [_vm._v(" $log.primary('primary style') ")]
      ),
      _c(
        "el-button",
        {
          attrs: { size: "small", type: "success" },
          on: {
            click: function($event) {
              return _vm.$log.success("success style")
            }
          }
        },
        [_vm._v(" $log.success('success style') ")]
      ),
      _c(
        "el-button",
        {
          attrs: { size: "small", type: "warning" },
          on: {
            click: function($event) {
              return _vm.$log.warning("warning style")
            }
          }
        },
        [_vm._v(" $log.warning('warning style') ")]
      ),
      _c(
        "el-button",
        {
          attrs: { size: "small", type: "danger" },
          on: {
            click: function($event) {
              return _vm.$log.danger("danger style")
            }
          }
        },
        [_vm._v(" $log.danger('danger style') ")]
      ),
      _c("p", [_vm._v("效果 ( Chrome )")]),
      _c("img", {
        staticClass: "page__image-demo",
        attrs: { src: require("./image/demo.png") }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }